import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

// Assign Pusher to window for Laravel Echo
window.Pusher = Pusher;

export const initializeEcho = (jwtToken) => {
  if (!jwtToken) {
    console.error('❌ Cannot initialize Echo: No JWT token provided');
    return null;
  }

  const config = {
    broadcaster: 'reverb',
    key: process.env.REACT_APP_REVERB_APP_KEY || '8ksyfqvhbbnf0vqitcxn', // ⭐ CHANGED: Use REVERB_APP_KEY
    wsHost: process.env.REACT_APP_REVERB_HOST || 'api.tinubu-ambode.org', // ⭐ CHANGED: Use REVERB_HOST
    wsPort: parseInt(process.env.REACT_APP_REVERB_PORT) || 8080, // ⭐ CHANGED: Use REVERB_PORT
    wssPort: parseInt(process.env.REACT_APP_REVERB_PORT) || 8080, // ⭐ CHANGED: Use REVERB_PORT
    forceTLS: (process.env.REACT_APP_REVERB_SCHEME || 'https') === 'https', // ⭐ CHANGED: Dynamic TLS
    enabledTransports: ['ws', 'wss'],
    disableStats: true,

    // ⭐ CRITICAL: Use the exact authEndpoint format they specified
    authEndpoint: `${process.env.REACT_APP_API_URL || 'https://api.tinubu-ambode.org'}/api/v1/broadcasting/auth`, // ⭐ CHANGED: Use API_URL

    // ⭐ CRITICAL: Authorization headers with JWT token
    auth: {
      headers: {
        'Authorization': `Bearer ${jwtToken}`, // ⭐ CHANGED: Quotes around key
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
    },
  };

  console.log('🔌 Echo Configuration:', {
    ...config,
    auth: { headers: { Authorization: 'Bearer ***' } } // Hide token in logs
  });

  const echo = new Echo(config);

  // ⭐ ADDED: Debugging events as requested by backend
  echo.connector.pusher.connection.bind('all', (eventName, data) => {
    console.log(`🔍 Pusher event: ${eventName}`, data);
  });

  echo.connector.pusher.connection.bind('state_change', (states) => {
    console.log('🔄 Connection state changed:', states.previous, '→', states.current);
  });

  echo.connector.pusher.connection.bind('error', (error) => {
    console.error('❌ Pusher connection error:', error);
  });

  echo.connector.pusher.connection.bind('connected', () => {
    console.log('🟢 Pusher connected successfully');
  });

  console.log('✅ Echo initialized successfully');
  return echo;
};

export default initializeEcho;